import React from 'react';

// based on https://github.com/akx/kekkonen

type LummeContext<TState, TAction> = [TState, React.Dispatch<TAction>];

export default function lummectx<TState, TAction>(reducer: React.Reducer<TState, TAction>, getInitialState: () => TState) {
  const Context = React.createContext<LummeContext<TState, TAction>>(undefined as any);

  function Provider({ children }: React.PropsWithChildren<{}>) {
    const [s, d] = React.useReducer(reducer, undefined, getInitialState);
    const value: LummeContext<TState, TAction> = React.useMemo(() => [s, d], [s, d]);
    return <Context.Provider value={value}>{children}</Context.Provider>;
  }
  function useState(): TState {
    return React.useContext(Context)[0];
  }
  function useDispatch(): React.Dispatch<TAction> {
    return React.useContext(Context)[1];
  }

  return { Provider, useDispatch, useState };
}
